export default {
  "LocationChangeContents.BackButtonText": "トップページへ戻る",
}
